import { initial as zoomConfig } from '../../../config/zoom';
import { IViewerStoreInjector, TYPES, appContainer } from '../../../inversify.config';
import { adjustScrollForCenteredZoom } from '../zoom-utils';

/**
 * Zooms out centered on the viewport center
 * This is for keyboard shortcuts where there's no cursor position
 */
const zoomCenteredOnViewport = (newZoom: number) => {
  const viewerStore = appContainer.get<IViewerStoreInjector>(TYPES.Store.Viewer);
  const { setZoom, zoom: currentZoom, pageMode } = viewerStore.getState();

  if (pageMode === 'single') {
    adjustScrollForCenteredZoom(currentZoom, newZoom);
  }

  setZoom(newZoom);
};

export const zoomOutShortcut = {
  key: new Set(['Control', 'Minus']),
  callBackFunction: () => {
    const { zoom, setViewOptions } = appContainer
      .get<IViewerStoreInjector>(TYPES.Store.Viewer)
      .getState();

    if (zoom <= zoomConfig.minZoom) return;

    setViewOptions(null);
    const newZoom = zoom - zoomConfig.zoomStep;

    zoomCenteredOnViewport(newZoom);
  },
};
